// extracted by mini-css-extract-plugin
export default {"selectedSeriesElement":"V1PxcFCl8isjoCqgxtv4","name":"maQNolSFNehm0KxU3E_k","bodyStyles":"GKyoT5OTca6_AOireD9j","seriesHeader":"KBItDHL1seJf465n1608"};